import { type RootState } from '../../store'

export const selectCategoryState = (state: RootState) => state.category
export const selectFeaturedCategories = (state: RootState) =>
  selectCategoryState(state).categories.slice(0, 5)
export const selectCategories = (state: RootState) => selectCategoryState(state).categories
export const selectedMenuCategories = (state: RootState) =>
  selectCategoryState(state).menuCategories
export const selectedMenuCategoryId = (state: RootState) =>
  selectCategoryState(state).menuCategoryId
export const selectedMenuCategory = (state: RootState) => selectCategoryState(state).menuCategory
export const selectedNavigateToCategory = (state: RootState) =>
  selectCategoryState(state).navigateToCategoryId
